import React from 'react';
import { Outlet } from 'react-router-dom';

const NonAcademicCreateVacancy: React.FC = () => <Outlet />;

export default NonAcademicCreateVacancy;
